export const getAccessToken = 'VF2_LOGIN_INFO';
export const getSoDetail = 'VF2_SO_DETAIL';
export const getGuestDetail = 'VF2_GUEST_DETAIL';
export const getAgentDetail = 'VF2_AGENT_DETAIL';
export const getGuestList = 'VF2_GUEST_LIST';
export const getGuestId = 'VF2_GUEST_ID';
export const vf2Logout = 'VF2_LOGOUT';
export const vf2Describe = 'VF2_DESCRIBE';

const INITIAL_STATE = {
    accessToken: '',
    accessTokenExpired: new Date().getTime(),
    soId: '',
    guestId: '',
    guestDetail: {},
    agentDetail: {},
    mainGuest: true,
    isLoginAsSalesAgent: false,
    guestList: {},
    soDetail: {},
    describe: {}
};

const ACTION_HANDLERS = {
    [getAccessToken]: (state, payload) => ({
        ...state,
        accessToken: payload.token,
        accessTokenExpired: payload.expired,
        soId: payload.soId,
        guestId: payload.guestId,
        mainGuest: payload.mainGuest,
        isLoginAsSalesAgent: payload.isLoginAsSalesAgent
    }),
    [getSoDetail]: (state, payload) => ({
        ...state,
        soDetail: payload,
    }),
    [getAgentDetail]: (state, payload) => ({
        ...state,
        agentDetail: payload.detail,
    }),
    [getGuestList]: (state, payload) => ({
        ...state,
        guestList: payload,
    }),
    [getGuestId]: (state, payload) => ({
        ...state,
        guestId: payload,
    }),
    [getGuestDetail]: (state, payload) => ({
        ...state,
        guestDetail: payload.detail,
    }),
    [vf2Describe]: (state, payload) => ({
        ...state,
        describe: payload,
    }),
    [vf2Logout]: () => INITIAL_STATE,
};


export default (state = INITIAL_STATE, { type, payload }) => {
    const fn = ACTION_HANDLERS[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};
